let IMask = require("imask");

//This function is used in 2 ways:
// -one: as a normal function, being called by map_binding_data.js , to do the data validation of input fields based on a mask
// -two: as a string that is passed to the CC editor (in the iframe) using this.editor.eval(....)

//The imask parameter is optional when used as a normal function. It is overriden when used inside the iframe
//Inside the iframe the IMask is inserted as a script at the beginning in cc-editor-2.tsx.
export function formatText (formatMask, input, imask = IMask) {
    let maskObj;
    switch(formatMask) {
        case undefined:
        case '':
            return input;
        case 'usd':
            maskObj = imask.createMask({
                mask: '$num',
                blocks: {
                    num: {
                        mask: Number,
                        thousandsSeparator: ','
                    }
                }
            });
            break;
        default:
            if(/^\/.*\/$/.exec(formatMask)) {
                //remove starting and ending / from regex string
                formatMask = formatMask.slice(1, -1);
                const regex = new RegExp(formatMask);
                maskObj = imask.createMask({mask: regex});
            } else {
                maskObj = imask.createMask({mask: formatMask});
            }
            break;
    }
    return maskObj.resolve(input ? input : '') ?? maskObj.value;
}

//This function creates the string that will be passed to the editor (iframe)
//It has the formatText function and the needed event listeners

export const appendUpdateFieldEvent = (inputMask, selector) => (
    `const formatText = ${formatText.toString()}

    function updateField(){
        let formattedText = formatText('${inputMask}', $('${selector}').val(), IMask );
        $(' ${selector} ').val(formattedText);
    };

    //apply change event to field
    $('${selector}').on('propertychange change click keyup input paste',updateField);

    //apply another event which will remove the previously applied event when triggered
    $('${selector}').on('removeChangeEvent',
        function(){
            $('${selector}').off('propertychange change click keyup input paste',updateField)
        }
    );`
);